import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'
import _ from 'lodash'
import { z } from 'zod'

import { MinimalCart, MinimalLineItem } from '../types/cart'

export const localCartAtom = atomWithStorage<MinimalCart | null>('cart', null)

export const getItemsCountAtom = atom((get) => {
    const cart = get(localCartAtom)
    if (!cart) return 0
    return cart?.items.reduce((acc, item) => acc + item.quantity, 0)
})

// * Handlers (FP style)

export const addLineItemAtom = atom(
    null,
    (get, set, lineItem: MinimalLineItem) => {
        const cart = get(localCartAtom)

        if (!cart) {
            return
        }

        const newCart: MinimalCart = {
            ...cart,
            items: [...cart.items, lineItem],
        }

        set(localCartAtom, newCart)
    },
)

export const AddLocalLineItemSchema = z.object({
    variant_id: z.string().min(1).max(255),
    quantity: z.number().min(1).max(100),
    unit_price: z.number().min(1).max(1000000),
    total: z.number().optional(),
})

export const removeLineItemAtom = atom(
    null,
    (get, set, lineItem: MinimalLineItem) => {
        const cart = get(localCartAtom)

        if (!cart) {
            return
        }

        const newCart: MinimalCart = {
            ...cart,
            items: cart.items.filter(
                (item) => item.variant_id !== lineItem.variant_id,
            ),
        }

        set(localCartAtom, newCart)
    },
)
